import * as React from 'react';

import CommentBubble16 from './CommentBubble16';

export const commentBubble16 = () => <CommentBubble16 />;

export default {
    title: 'Icon/Line/CommentBubble16',
    component: CommentBubble16,
    parameters: {
        notes: "`import CommentBubble16 from 'box-ui-elements/es/icon/line/CommentBubble16';`",
    },
};
